// This file is AUTOGENERATED, do not edit it manually!!!

import { resourcePlanning as resourcePlanningde } from './resourcePlanningResx.de';
import { resourcePlanning as resourcePlanningen } from './resourcePlanningResx.en';
import { resourcePlanning as resourcePlanningen_risk } from './resourcePlanningResx.en_risk';
import { resourcePlanning as resourcePlanninges } from './resourcePlanningResx.es';
import { resourcePlanning as resourcePlanningfr } from './resourcePlanningResx.fr';
import { resourcePlanning as resourcePlanningit } from './resourcePlanningResx.it';
import { resourcePlanning as resourcePlanningnl } from './resourcePlanningResx.nl';
import { resourcePlanning as resourcePlanningpl } from './resourcePlanningResx.pl';
import { resourcePlanning as resourcePlanningpt } from './resourcePlanningResx.pt';
import { resourcePlanning as resourcePlanningru } from './resourcePlanningResx.ru';
import { resourcePlanning as resourcePlanningsk } from './resourcePlanningResx.sk';
import { resourcePlanning as resourcePlanningsv } from './resourcePlanningResx.sv';
import { resourcePlanning as resourcePlanningtr } from './resourcePlanningResx.tr';

const langMap: { [k: string]: Partial<typeof resourcePlanningen> } = {
    de: resourcePlanningde,
    en: resourcePlanningen,
    en_risk: resourcePlanningen_risk,
    es: resourcePlanninges,
    fr: resourcePlanningfr,
    it: resourcePlanningit,
    nl: resourcePlanningnl,
    pl: resourcePlanningpl,
    pt: resourcePlanningpt,
    ru: resourcePlanningru,
    sk: resourcePlanningsk,
    sv: resourcePlanningsv,
    tr: resourcePlanningtr,
};

/* tslint:disable: max-line-length */
export const resourcePlanningResx = {
    get ability_to_fit_label() {
        return langMap[ep.resxCulture].ability_to_fit_label || langMap.en.ability_to_fit_label;
    },
    get add_allocation_title() {
        return langMap[ep.resxCulture].add_allocation_title || langMap.en.add_allocation_title;
    },
    get add_approver_button() {
        return langMap[ep.resxCulture].add_approver_button || langMap.en.add_approver_button;
    },
    get add_to_project() {
        return langMap[ep.resxCulture].add_to_project || langMap.en.add_to_project;
    },
    get add_user_link() {
        return langMap[ep.resxCulture].add_user_link || langMap.en.add_user_link;
    },
    get allocate_resources() {
        return langMap[ep.resxCulture].allocate_resources || langMap.en.allocate_resources;
    },
    get allocated_label() {
        return langMap[ep.resxCulture].allocated_label || langMap.en.allocated_label;
    },
    get AllocatedHoursColumn() {
        return langMap[ep.resxCulture].AllocatedHoursColumn || langMap.en.AllocatedHoursColumn;
    },
    get allocation_approved_alert() {
        return langMap[ep.resxCulture].allocation_approved_alert || langMap.en.allocation_approved_alert;
    },
    get allocation_hard_label() {
        return langMap[ep.resxCulture].allocation_hard_label || langMap.en.allocation_hard_label;
    },
    get allocation_has_been_created() {
        return langMap[ep.resxCulture].allocation_has_been_created || langMap.en.allocation_has_been_created;
    },
    get allocation_has_been_updated() {
        return langMap[ep.resxCulture].allocation_has_been_updated || langMap.en.allocation_has_been_updated;
    },
    get allocation_percentage_label() {
        return langMap[ep.resxCulture].allocation_percentage_label || langMap.en.allocation_percentage_label;
    },
    get allocation_period_conflict() {
        return langMap[ep.resxCulture].allocation_period_conflict || langMap.en.allocation_period_conflict;
    },
    get allocation_reject_alert() {
        return langMap[ep.resxCulture].allocation_reject_alert || langMap.en.allocation_reject_alert;
    },
    get allocation_request_approved_feedback() {
        return langMap[ep.resxCulture].allocation_request_approved_feedback || langMap.en.allocation_request_approved_feedback;
    },
    get allocation_request_rejected_feedback() {
        return langMap[ep.resxCulture].allocation_request_rejected_feedback || langMap.en.allocation_request_rejected_feedback;
    },
    get allocation_request_waiting_feedback() {
        return langMap[ep.resxCulture].allocation_request_waiting_feedback || langMap.en.allocation_request_waiting_feedback;
    },
    get allocation_required() {
        return langMap[ep.resxCulture].allocation_required || langMap.en.allocation_required;
    },
    get allocation_soft_label() {
        return langMap[ep.resxCulture].allocation_soft_label || langMap.en.allocation_soft_label;
    },
    get allocation_type_change_with_approval_rquest_warning() {
        return langMap[ep.resxCulture].allocation_type_change_with_approval_rquest_warning || langMap.en.allocation_type_change_with_approval_rquest_warning;
    },
    get allocation_type_description() {
        return langMap[ep.resxCulture].allocation_type_description || langMap.en.allocation_type_description;
    },
    get allocation_type_label() {
        return langMap[ep.resxCulture].allocation_type_label || langMap.en.allocation_type_label;
    },
    get allocation_waiting_alert() {
        return langMap[ep.resxCulture].allocation_waiting_alert || langMap.en.allocation_waiting_alert;
    },
    get approve_modal_header_text() {
        return langMap[ep.resxCulture].approve_modal_header_text || langMap.en.approve_modal_header_text;
    },
    get approve_request() {
        return langMap[ep.resxCulture].approve_request || langMap.en.approve_request;
    },
    get approve_request_info() {
        return langMap[ep.resxCulture].approve_request_info || langMap.en.approve_request_info;
    },
    get Approve_Success_Message() {
        return langMap[ep.resxCulture].Approve_Success_Message || langMap.en.Approve_Success_Message;
    },
    get approved_by() {
        return langMap[ep.resxCulture].approved_by || langMap.en.approved_by;
    },
    get approver() {
        return langMap[ep.resxCulture].approver || langMap.en.approver;
    },
    get AvailabilityTooltip() {
        return langMap[ep.resxCulture].AvailabilityTooltip || langMap.en.AvailabilityTooltip;
    },
    get available_label() {
        return langMap[ep.resxCulture].available_label || langMap.en.available_label;
    },
    get available_projects() {
        return langMap[ep.resxCulture].available_projects || langMap.en.available_projects;
    },
    get awaiting_approval_from() {
        return langMap[ep.resxCulture].awaiting_approval_from || langMap.en.awaiting_approval_from;
    },
    get be_aware_all_will_be_transferred() {
        return langMap[ep.resxCulture].be_aware_all_will_be_transferred || langMap.en.be_aware_all_will_be_transferred;
    },
    get calculate_based_message() {
        return langMap[ep.resxCulture].calculate_based_message || langMap.en.calculate_based_message;
    },
    get capacity_label() {
        return langMap[ep.resxCulture].capacity_label || langMap.en.capacity_label;
    },
    get check_all() {
        return langMap[ep.resxCulture].check_all || langMap.en.check_all;
    },
    get choice_description_generate_on_project_timeline() {
        return langMap[ep.resxCulture].choice_description_generate_on_project_timeline || langMap.en.choice_description_generate_on_project_timeline;
    },
    get choice_description_generate_on_scheduled_hours() {
        return langMap[ep.resxCulture].choice_description_generate_on_scheduled_hours || langMap.en.choice_description_generate_on_scheduled_hours;
    },
    get choice_title_generate_on_project_timeline() {
        return langMap[ep.resxCulture].choice_title_generate_on_project_timeline || langMap.en.choice_title_generate_on_project_timeline;
    },
    get choice_title_generate_on_scheduled_hours() {
        return langMap[ep.resxCulture].choice_title_generate_on_scheduled_hours || langMap.en.choice_title_generate_on_scheduled_hours;
    },
    get column_title_availability() {
        return langMap[ep.resxCulture].column_title_availability || langMap.en.column_title_availability;
    },
    get column_title_job_role() {
        return langMap[ep.resxCulture].column_title_job_role || langMap.en.column_title_job_role;
    },
    get column_title_resource() {
        return langMap[ep.resxCulture].column_title_resource || langMap.en.column_title_resource;
    },
    get column_title_skills() {
        return langMap[ep.resxCulture].column_title_skills || langMap.en.column_title_skills;
    },
    get column_title_user() {
        return langMap[ep.resxCulture].column_title_user || langMap.en.column_title_user;
    },
    get company_schedule_link() {
        return langMap[ep.resxCulture].company_schedule_link || langMap.en.company_schedule_link;
    },
    get completed_projects_label() {
        return langMap[ep.resxCulture].completed_projects_label || langMap.en.completed_projects_label;
    },
    get copy_multiple_times_message() {
        return langMap[ep.resxCulture].copy_multiple_times_message || langMap.en.copy_multiple_times_message;
    },
    get copy_unnamed_title() {
        return langMap[ep.resxCulture].copy_unnamed_title || langMap.en.copy_unnamed_title;
    },
    get copy_with_allocations_label() {
        return langMap[ep.resxCulture].copy_with_allocations_label || langMap.en.copy_with_allocations_label;
    },
    get demand_label() {
        return langMap[ep.resxCulture].demand_label || langMap.en.demand_label;
    },
    get Description_AllocatedMinutes() {
        return langMap[ep.resxCulture].Description_AllocatedMinutes || langMap.en.Description_AllocatedMinutes;
    },
    get Description_HourlyRateInternal() {
        return langMap[ep.resxCulture].Description_HourlyRateInternal || langMap.en.Description_HourlyRateInternal;
    },
    get Description_ScheduledMinutes() {
        return langMap[ep.resxCulture].Description_ScheduledMinutes || langMap.en.Description_ScheduledMinutes;
    },
    get edit_allocation_title() {
        return langMap[ep.resxCulture].edit_allocation_title || langMap.en.edit_allocation_title;
    },
    get effortlessly_namage_resources_label() {
        return langMap[ep.resxCulture].effortlessly_namage_resources_label || langMap.en.effortlessly_namage_resources_label;
    },
    get find_candidates() {
        return langMap[ep.resxCulture].find_candidates || langMap.en.find_candidates;
    },
    get find_candidates_not_available_no_unnamed() {
        return langMap[ep.resxCulture].find_candidates_not_available_no_unnamed || langMap.en.find_candidates_not_available_no_unnamed;
    },
    get free() {
        return langMap[ep.resxCulture].free || langMap.en.free;
    },
    get generate_allocations_action() {
        return langMap[ep.resxCulture].generate_allocations_action || langMap.en.generate_allocations_action;
    },
    get generate_allocations_button() {
        return langMap[ep.resxCulture].generate_allocations_button || langMap.en.generate_allocations_button;
    },
    get generate_allocations_description() {
        return langMap[ep.resxCulture].generate_allocations_description || langMap.en.generate_allocations_description;
    },
    get generate_allocations_info() {
        return langMap[ep.resxCulture].generate_allocations_info || langMap.en.generate_allocations_info;
    },
    get generate_allocations_to_have_scheduled_hours() {
        return langMap[ep.resxCulture].generate_allocations_to_have_scheduled_hours || langMap.en.generate_allocations_to_have_scheduled_hours;
    },
    get generate_button() {
        return langMap[ep.resxCulture].generate_button || langMap.en.generate_button;
    },
    get generate_button_warning_text() {
        return langMap[ep.resxCulture].generate_button_warning_text || langMap.en.generate_button_warning_text;
    },
    get generate_hard_allocation_disabled_tooltip_description() {
        return langMap[ep.resxCulture].generate_hard_allocation_disabled_tooltip_description || langMap.en.generate_hard_allocation_disabled_tooltip_description;
    },
    get generate_hard_allocation_tooltip_description() {
        return langMap[ep.resxCulture].generate_hard_allocation_tooltip_description || langMap.en.generate_hard_allocation_tooltip_description;
    },
    get generate_label() {
        return langMap[ep.resxCulture].generate_label || langMap.en.generate_label;
    },
    get generate_modal_description_text() {
        return langMap[ep.resxCulture].generate_modal_description_text || langMap.en.generate_modal_description_text;
    },
    get generate_modal_description_text_single_resource() {
        return langMap[ep.resxCulture].generate_modal_description_text_single_resource || langMap.en.generate_modal_description_text_single_resource;
    },
    get generate_modal_header_text() {
        return langMap[ep.resxCulture].generate_modal_header_text || langMap.en.generate_modal_header_text;
    },
    get generate_modal_header_text_single_resource() {
        return langMap[ep.resxCulture].generate_modal_header_text_single_resource || langMap.en.generate_modal_header_text_single_resource;
    },
    get generate_success_message() {
        return langMap[ep.resxCulture].generate_success_message || langMap.en.generate_success_message;
    },
    get group_by_job_role_label() {
        return langMap[ep.resxCulture].group_by_job_role_label || langMap.en.group_by_job_role_label;
    },
    get group_by_project_label() {
        return langMap[ep.resxCulture].group_by_project_label || langMap.en.group_by_project_label;
    },
    get group_by_resource_label() {
        return langMap[ep.resxCulture].group_by_resource_label || langMap.en.group_by_resource_label;
    },
    get HardAllocation() {
        return langMap[ep.resxCulture].HardAllocation || langMap.en.HardAllocation;
    },
    get HardAllocationTooltip() {
        return langMap[ep.resxCulture].HardAllocationTooltip || langMap.en.HardAllocationTooltip;
    },
    get help_tooltip_description() {
        return langMap[ep.resxCulture].help_tooltip_description || langMap.en.help_tooltip_description;
    },
    get HourlyRateInternalColumn() {
        return langMap[ep.resxCulture].HourlyRateInternalColumn || langMap.en.HourlyRateInternalColumn;
    },
    get include_soft_allocations_to_workload() {
        return langMap[ep.resxCulture].include_soft_allocations_to_workload || langMap.en.include_soft_allocations_to_workload;
    },
    get job_role_capacity() {
        return langMap[ep.resxCulture].job_role_capacity || langMap.en.job_role_capacity;
    },
    get legend_title() {
        return langMap[ep.resxCulture].legend_title || langMap.en.legend_title;
    },
    get message() {
        return langMap[ep.resxCulture].message || langMap.en.message;
    },
    get message_tooltip() {
        return langMap[ep.resxCulture].message_tooltip || langMap.en.message_tooltip;
    },
    get name_column_group_by_JobRole() {
        return langMap[ep.resxCulture].name_column_group_by_JobRole || langMap.en.name_column_group_by_JobRole;
    },
    get name_column_group_by_Project() {
        return langMap[ep.resxCulture].name_column_group_by_Project || langMap.en.name_column_group_by_Project;
    },
    get name_column_group_by_User() {
        return langMap[ep.resxCulture].name_column_group_by_User || langMap.en.name_column_group_by_User;
    },
    get no_jobrole() {
        return langMap[ep.resxCulture].no_jobrole || langMap.en.no_jobrole;
    },
    get no_jobrole_match_selected_filters() {
        return langMap[ep.resxCulture].no_jobrole_match_selected_filters || langMap.en.no_jobrole_match_selected_filters;
    },
    get no_project() {
        return langMap[ep.resxCulture].no_project || langMap.en.no_project;
    },
    get no_project_match_selected_filters() {
        return langMap[ep.resxCulture].no_project_match_selected_filters || langMap.en.no_project_match_selected_filters;
    },
    get no_scheduled_hours_description() {
        return langMap[ep.resxCulture].no_scheduled_hours_description || langMap.en.no_scheduled_hours_description;
    },
    get no_user() {
        return langMap[ep.resxCulture].no_user || langMap.en.no_user;
    },
    get no_user_match_selected_filters() {
        return langMap[ep.resxCulture].no_user_match_selected_filters || langMap.en.no_user_match_selected_filters;
    },
    get NormalizeApprovers_Feedback() {
        return langMap[ep.resxCulture].NormalizeApprovers_Feedback || langMap.en.NormalizeApprovers_Feedback;
    },
    get other_hard_allocations() {
        return langMap[ep.resxCulture].other_hard_allocations || langMap.en.other_hard_allocations;
    },
    get other_projects_label() {
        return langMap[ep.resxCulture].other_projects_label || langMap.en.other_projects_label;
    },
    get other_projects_tooltip() {
        return langMap[ep.resxCulture].other_projects_tooltip || langMap.en.other_projects_tooltip;
    },
    get over() {
        return langMap[ep.resxCulture].over || langMap.en.over;
    },
    get overloaded_label() {
        return langMap[ep.resxCulture].overloaded_label || langMap.en.overloaded_label;
    },
    get overscheduled_hours_label() {
        return langMap[ep.resxCulture].overscheduled_hours_label || langMap.en.overscheduled_hours_label;
    },
    get planning_onboarding_description() {
        return langMap[ep.resxCulture].planning_onboarding_description || langMap.en.planning_onboarding_description;
    },
    get planning_onboarding_title() {
        return langMap[ep.resxCulture].planning_onboarding_title || langMap.en.planning_onboarding_title;
    },
    get project_timeline_label() {
        return langMap[ep.resxCulture].project_timeline_label || langMap.en.project_timeline_label;
    },
    get recommended_users_label() {
        return langMap[ep.resxCulture].recommended_users_label || langMap.en.recommended_users_label;
    },
    get regenerate_allocations_button() {
        return langMap[ep.resxCulture].regenerate_allocations_button || langMap.en.regenerate_allocations_button;
    },
    get regenerate_allocations_info() {
        return langMap[ep.resxCulture].regenerate_allocations_info || langMap.en.regenerate_allocations_info;
    },
    get regenerate_button() {
        return langMap[ep.resxCulture].regenerate_button || langMap.en.regenerate_button;
    },
    get regenerate_hard_allocation_disabled_tooltip_description() {
        return langMap[ep.resxCulture].regenerate_hard_allocation_disabled_tooltip_description || langMap.en.regenerate_hard_allocation_disabled_tooltip_description;
    },
    get regenerate_hard_allocation_tooltip_description() {
        return langMap[ep.resxCulture].regenerate_hard_allocation_tooltip_description || langMap.en.regenerate_hard_allocation_tooltip_description;
    },
    get regenerate_label() {
        return langMap[ep.resxCulture].regenerate_label || langMap.en.regenerate_label;
    },
    get regenerate_modal_description_text() {
        return langMap[ep.resxCulture].regenerate_modal_description_text || langMap.en.regenerate_modal_description_text;
    },
    get regenerate_modal_header_text() {
        return langMap[ep.resxCulture].regenerate_modal_header_text || langMap.en.regenerate_modal_header_text;
    },
    get regenerate_success_message() {
        return langMap[ep.resxCulture].regenerate_success_message || langMap.en.regenerate_success_message;
    },
    get regular_workload_label() {
        return langMap[ep.resxCulture].regular_workload_label || langMap.en.regular_workload_label;
    },
    get reject_modal_header_text() {
        return langMap[ep.resxCulture].reject_modal_header_text || langMap.en.reject_modal_header_text;
    },
    get reject_request() {
        return langMap[ep.resxCulture].reject_request || langMap.en.reject_request;
    },
    get reject_request_info() {
        return langMap[ep.resxCulture].reject_request_info || langMap.en.reject_request_info;
    },
    get Reject_Success_Message() {
        return langMap[ep.resxCulture].Reject_Success_Message || langMap.en.Reject_Success_Message;
    },
    get rejected_by() {
        return langMap[ep.resxCulture].rejected_by || langMap.en.rejected_by;
    },
    get remaining_total_capacity() {
        return langMap[ep.resxCulture].remaining_total_capacity || langMap.en.remaining_total_capacity;
    },
    get remaining_user_capacity() {
        return langMap[ep.resxCulture].remaining_user_capacity || langMap.en.remaining_user_capacity;
    },
    get replace_unnamed_with_real_to_approve_allocation() {
        return langMap[ep.resxCulture].replace_unnamed_with_real_to_approve_allocation || langMap.en.replace_unnamed_with_real_to_approve_allocation;
    },
    get replace_with_a_user() {
        return langMap[ep.resxCulture].replace_with_a_user || langMap.en.replace_with_a_user;
    },
    get request_for_approval_label() {
        return langMap[ep.resxCulture].request_for_approval_label || langMap.en.request_for_approval_label;
    },
    get request_from() {
        return langMap[ep.resxCulture].request_from || langMap.en.request_from;
    },
    get resource_allocated_plural() {
        return langMap[ep.resxCulture].resource_allocated_plural || langMap.en.resource_allocated_plural;
    },
    get resource_approval_selector_disabled_label() {
        return langMap[ep.resxCulture].resource_approval_selector_disabled_label || langMap.en.resource_approval_selector_disabled_label;
    },
    get resource_types_disabled_user_label() {
        return langMap[ep.resxCulture].resource_types_disabled_user_label || langMap.en.resource_types_disabled_user_label;
    },
    get scheduled_hours_label() {
        return langMap[ep.resxCulture].scheduled_hours_label || langMap.en.scheduled_hours_label;
    },
    get see_detailed_allocations() {
        return langMap[ep.resxCulture].see_detailed_allocations || langMap.en.see_detailed_allocations;
    },
    get select_user() {
        return langMap[ep.resxCulture].select_user || langMap.en.select_user;
    },
    get SkillsColumn() {
        return langMap[ep.resxCulture].SkillsColumn || langMap.en.SkillsColumn;
    },
    get soft_allocation_with_a_resource_request_options() {
        return langMap[ep.resxCulture].soft_allocation_with_a_resource_request_options || langMap.en.soft_allocation_with_a_resource_request_options;
    },
    get SoftAllocation() {
        return langMap[ep.resxCulture].SoftAllocation || langMap.en.SoftAllocation;
    },
    get streamline_your_project() {
        return langMap[ep.resxCulture].streamline_your_project || langMap.en.streamline_your_project;
    },
    get total_allocated_hours_calculation_description() {
        return langMap[ep.resxCulture].total_allocated_hours_calculation_description || langMap.en.total_allocated_hours_calculation_description;
    },
    get total_allocated_hours_calculation_formula() {
        return langMap[ep.resxCulture].total_allocated_hours_calculation_formula || langMap.en.total_allocated_hours_calculation_formula;
    },
    get total_allocated_hours_label() {
        return langMap[ep.resxCulture].total_allocated_hours_label || langMap.en.total_allocated_hours_label;
    },
    get total_demand() {
        return langMap[ep.resxCulture].total_demand || langMap.en.total_demand;
    },
    get uncheck_all() {
        return langMap[ep.resxCulture].uncheck_all || langMap.en.uncheck_all;
    },
    get underloaded_label() {
        return langMap[ep.resxCulture].underloaded_label || langMap.en.underloaded_label;
    },
    get unnamed_resource_allocation() {
        return langMap[ep.resxCulture].unnamed_resource_allocation || langMap.en.unnamed_resource_allocation;
    },
    get unnamed_resource_demand() {
        return langMap[ep.resxCulture].unnamed_resource_demand || langMap.en.unnamed_resource_demand;
    },
    get unnamed_workload_label() {
        return langMap[ep.resxCulture].unnamed_workload_label || langMap.en.unnamed_workload_label;
    },
    get user_demand() {
        return langMap[ep.resxCulture].user_demand || langMap.en.user_demand;
    },
    get users_select_empty_text() {
        return langMap[ep.resxCulture].users_select_empty_text || langMap.en.users_select_empty_text;
    },
    get vacation_label() {
        return langMap[ep.resxCulture].vacation_label || langMap.en.vacation_label;
    },
    get working_hours_message() {
        return langMap[ep.resxCulture].working_hours_message || langMap.en.working_hours_message;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.resourcePlanning = resourcePlanningResx;
